import DetalleCentro from 'components/centros/DetalleCentro'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewDetalleCentro = () => {
  return (
    <Row>
        <Col>
            <DetalleCentro>
              
            </DetalleCentro>
        </Col>
    </Row>
  )
}

export default ViewDetalleCentro